(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-plans-config]').textContent);
    let billing = 'annual';
    const money = n => '$' + n.toLocaleString('en-US');
    function update() {
      root.querySelectorAll('[data-billing]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.billing === billing)));
      config.plans.forEach(plan => {
        const card = root.querySelector(`[data-plan="${plan.id}"]`);
        const quoted = plan[billing] == null;
        const signup = new URL('https://live.gotak.dev/signup');
        signup.searchParams.set('plan', plan.id);
        signup.searchParams.set('interval', billing === 'annual' ? 'year' : 'month');
        card.querySelector('a.gkp-secondary').href = signup.href;
        card.querySelector('[data-price]').textContent = quoted ? 'Let’s talk' : money(plan[billing]);
        card.querySelector('[data-period]').textContent = quoted ? '' : billing === 'annual' ? '/yr' : '/mo';
        card.querySelector('[data-annual-note]').textContent = quoted ? 'Annual pricing scoped with our team.' : billing === 'annual' ? `Billed annually. Approximately ${money(Math.round(plan.annual / 12))}/month.` : '';
      });

    }
    root.addEventListener('click', event => {
      const b = event.target.closest('[data-billing]');
      if (b) billing = b.dataset.billing;
      if (b) update();
    });
    update();
  }
  document.querySelectorAll('[data-takos-plans]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-takos-plans]').forEach(init));
})();
